<template>
  <div class="btxBox">
    <div class="btn">
      <van-button plain hairline type="primary" size="large" style="color:#ff9db5; border-color: #ff9db5" @click.stop="handleLogin">
        {{ msg }}</van-button>
    </div>
    <div class="btn">
      <van-button type="primary" size="large" style="background-color: #ff9db5;border-color: #ff9db5" @click.stop="handleRegister">{{msg2}}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  props:["msg", "msg2"],
  methods:{
    handleLogin(){
      this.$emit("login");
    },
    handleRegister(){
      this.$emit("register");
    }
  }
}
</script>


<style scoped lang="scss">
  .btxBox{
    display: flex;
    padding: 5.556vw 2vw;
  }
  .btn{
    width: 50%;
    margin: 1.2vw;
  }
</style>
